/**
 * @file ReturnToQueueConfirm.tsx
 * @description Подтверждение «Вернуть оператору» (chat-window-design.md §4,
 * §7): «Вернуть диалог оператору? Он пропадёт из вашего списка, его увидят
 * владелец и оператор заказов.» [Вернуть] [Отмена]. Общее окно
 * подтверждения кабинета (`alert-dialog`), на телефоне — на весь экран.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { CHAT_TEXT } from "./chat-texts";

interface Props {
  open: boolean;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ReturnToQueueConfirm({ open, busy, onClose, onConfirm }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && !busy && onClose()}>
      <AlertDialogContent fullScreen>
        <AlertDialogHeader>
          <AlertDialogTitle>{CHAT_TEXT.confirmReturnTitle}</AlertDialogTitle>
          <AlertDialogDescription>{CHAT_TEXT.confirmReturnText}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" className="min-h-12 sm:min-h-10" disabled={busy} onClick={onClose}>
            {CHAT_TEXT.cancel}
          </Button>
          <Button variant="warning" className="min-h-12 sm:min-h-10" loading={busy} onClick={onConfirm}>
            {CHAT_TEXT.confirmReturnAction}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
